import {Box, FormControl, MenuItem, Select} from "@mui/material"
import {useEffect, useState} from "react"

export function FontSizeMenu({editor, editorState}) {
	const [fontSize, setFontSize] = useState("16px")

	const changeFontSize = (e) => {
		const cannotSetFontSize = editorState.isHeading || editorState.isImage
		if(cannotSetFontSize) {
			return
		} else {
			const newFontSize = e.target.value
			setFontSize(newFontSize)
			editor.chain().focus().setFontSize(newFontSize).run()
		}
	}

	useEffect(() => {
		const changedFontSize = editorState.currentFontSize
		const activeTextStyle = editor.isActive("textStyle")
		const cannotSetFontSize = editorState.isHeading || editorState.isImage

		if(cannotSetFontSize) {
			setFontSize("")
		} else if(changedFontSize || activeTextStyle) {
			const newFontSize = editor.getAttributes("textStyle").fontSize
			setFontSize(newFontSize)
		} else {
			setFontSize("16px")
		}

	}, [editorState.currentFontSize, editorState.isImage, editorState.isHeading])

	return (
		<Box sx={{
			height: "48px",
			width: "82px",
			display: "flex",
			alignItems: "center",
			border: "1px solid rgba(0, 0, 0, 0.42)",
			borderRadius: "4px",
		}}>
			<FormControl size="small" sx={{ minWidth: "80px", }}>
				<Select
					value={fontSize}
					defaultValue={fontSize}
					onChange={changeFontSize}
					disabled={fontSize === ""}
					variant={"filled"}
					label={"Font Size"}
					sx={{ borderBottom: "none" }}
					inputProps={{
						sx: {
							paddingTop: "12px",
							paddingBottom: "12px",
						}
					}}
				>
					<MenuItem value={"16px"}>16px</MenuItem>
					<MenuItem value={"32px"}>32px</MenuItem>
					<MenuItem value={"64px"}>64px</MenuItem>
				</Select>
			</FormControl>
		</Box>
	)
}